import { DeliveryMethod } from '@context/Delivery/types';

export const ROOT = '/';
export const DOCTOR_SELECTION = {
  ROOT: '/departments',
  UNTACT_DEPARTMENT_ID: '/departments/:untactDepartmentId',
  DOCTOR_ID: '/departments/:untactDepartmentId/doctors/:doctorId'
};
export const generateDoctorSelectionPath = (untactDepartmentId: string) => {
  return `${DOCTOR_SELECTION.ROOT}/${untactDepartmentId}`;
};
export const generateDoctorDetailPath = (
  untactDepartmentId: string,
  doctorId: string
) => {
  return `${generateDoctorSelectionPath(untactDepartmentId)}/doctors/${doctorId}`;
};

export const PATIENT = {
  ROOT: '/patient',
  NAME: '/patient/name',
  RRN: '/patient/rrn',
  AGREEMENT: '/patient/agreement'
};

export const MATCHING = '/matching';
export const MATCHING_FAIL = '/matchingfail';
export const VIDEO_CALL = '/video-call';
export const END_INSTRUCTION = '/end-instruction';

export const HISTORY = '/history';
export const ADVERTISEMENT = '/advertise';

export const HISTORY_DETAIL = '/history/:treatmentId';
export const generateHistoryDetailPath = (treatmentId: string) => {
  return `${HISTORY}/${treatmentId}`;
};

export const TargetPayment = {
  treatment: 'treatment',
  prescription: 'prescription',
  delivery: 'delivery'
} as const;
export type TargetPaymentTypes = keyof typeof TargetPayment;

export const PAYMENT = {
  ROOT: '/payment',
  SELECT: '/payment/:type',
  REGISTRATION: '/payment/registration',
  TREATMENT_COMPLETE: '/payment/treatment/complete',
  TREATMENT_ID: '/payment/treatment/complete/:treatmentId/:isPrescriptionExists'
};
export const generateSelectPaymentPath = (type: TargetPaymentTypes) => {
  return `${PAYMENT.ROOT}/${type}`;
};
export const generateTreatmentPaymentCompletePath = (
  treatmentId: string,
  isPrescriptionExists: boolean
) => {
  return `${PAYMENT.TREATMENT_COMPLETE}/${treatmentId}/${isPrescriptionExists}`;
};

export const POST_PAYMENT = {
  TYPE_ID: '/payment/:type/:typeId'
};
export const generatePaymentPath = (type: TargetPaymentTypes, typeId: string) => {
  return `${PAYMENT.ROOT}/${type}/${typeId}`;
};

export const RETRY_PAYMENT = {
  ROOT: '/payment/retry',
  TREATMENT_ID: '/payment/retry/:treatmentId'
};
export const generateRetryPaymentPath = (treatmentId: string) => {
  return `${RETRY_PAYMENT.ROOT}/${treatmentId}`;
};

export const PRESCRIPTION = {
  ROOT: '/prescription',
  TREATMENT_ID: '/prescription/:treatmentId'
};
export const generatePrescriptionPath = (treatmentId: string) => {
  return `${PRESCRIPTION.ROOT}/${treatmentId}`;
};

export const DELIVERY = {
  ROOT: '/delivery',
  METHOD: '/delivery/:treatmentId/:deliveryMethod',
};
export const generateDeliveryPath = (
  treatmentId: string,
  deliveryMethod: DeliveryMethod
) => {
  return `${DELIVERY.ROOT}/${treatmentId}/${deliveryMethod}`;
};

export const SIGN_IN = '/signIn';
export const SIGN_OUT = '/signOut';
export const EXIT = '/exit';
